import { createFileRoute } from '@tanstack/react-router';
import { PetParks } from '@/pet/src/features/pet-parks/PetParks';
import { usePets } from '@/pet/src/context/PetsContext';

export const Route = createFileRoute('/dashboard/pet-parks')({
  component: PetsoPetParks,
});

function PetsoPetParks() {
  const { pets, selectedPetId, setSelectedPetId } = usePets();

  return (
    <PetParks
      pets={pets}
      selectedPetId={selectedPetId ?? undefined}
      onSelectPetId={setSelectedPetId}
    />
  );
}
